import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Company } from 'src/app/models/company.model';
import { User, UserList } from 'src/app/models/user.model';
import { CompanysService } from 'src/app/services/companies/companies.service';
import { UserService } from 'src/app/services/user/user.service';

@Component({
  selector: 'app-edit-company',
  templateUrl: './edit-company.component.html',
  styleUrls: ['./edit-company.component.css'],
})
export class EditCompanyComponent {
  companyDetails: Company = new Company();
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private companysService: CompanysService,
    private userService: UserService,
    private toastr: ToastrService
  ) {}

  
  userList: UserList[] = [];
  formatsDateTest: string[] = ['yyyy/MM/dd HH:mm:ss'];
  dateNow: Date = new Date();
  companyId: any;

  ngOnInit(): void {
    let loggedInuserRole = JSON.parse(atob(sessionStorage.getItem('currentUser')!));
 if(loggedInuserRole.role =='Standard User' || loggedInuserRole.role=='Regional User')
 {
    this.logout();
 }
    this.route.paramMap.subscribe({
      next: (params) => {
        const id = atob(params.get('id')!);
        if (id) {
          this.companysService.getCompany(id).subscribe({
            next: (response) => {
              console.log(response);
              this.companyDetails = response;
              
            },
          });

          this.userService.GetUserListByCompanyId(id).subscribe(
            (response: UserList[]) => {
              this.userList = response;
              console.log(this.userList);
            },
            (error: any) => {
              console.log('error list');
            }
          );
        }
      },
    });
  }

  navigatToUser(Tid){
    var id = btoa(Tid.toString());
    this.router.navigate(['/user/edit/' + id]);
  }

  updateCompany() {
    const dateNowISO = this.dateNow.toISOString();
    this.companyDetails.UpdatedAt = dateNowISO;
    if (this.companyDetails.Address == "") {
      this.companyDetails.Address = "";
    }

    if (this.companyDetails.ContactName == "") {
    this.companyDetails.ContactName = "";
    }

    if (this.companyDetails.ContactAddress == "") {
    this.companyDetails.ContactAddress = "";
    }

    if (this.companyDetails.ContactPhone == "") {
    this.companyDetails.ContactPhone = "";
    }
    
    this.companysService
      .updateCompany(this.companyDetails.Id, this.companyDetails)
      .subscribe({
        next: (response) => {
          this.toastr.success('Company Updated successfully.', 'Information');
          this.router.navigate(['/companies']);
        },
      });
  }

  deleteCompany(id: number) {
  
    this.companyId = id + "";
    this.userService.GetUserListByCompanyId(this.companyId).subscribe(
      (response: UserList[]) => {
        this.userList = response;
        if (this.userList.length > 0) {
          const confirmDelete = confirm(
            'This Company Has ' +
              this.userList.length +
              ' Users. Are you sure you want to delete this company?'
          );
  
          if (!confirmDelete) {
            return; // If the user clicks "Cancel" in the confirmation dialog, do nothing.
          }
        }
        
        else{
          const confirmDelete = confirm(
          'Are you sure you want to delete this company?'
        );

        if (!confirmDelete) {
          return; // If the user clicks "Cancel" in the confirmation dialog, do nothing.
        }
        }

        // If the user clicks "OK" in the confirmation dialog or there are no users, proceed with the deletion.
        this.companysService.deleteCompany(id)
          .subscribe((response: Response) => {
            if (response.statusText == 'Success') {
              this.toastr.error('Company deleted successfully.', 'Information');
              this.router.navigate(['/companies']);
            } else {
              (error) => {
                console.log('Error deleting Company:', error);
              };
            }
          });
      },
      (error: any) => {
        console.log('Error fetching user list:', error);
        // Handle or display an error message as needed.
      }
    );
  }
  logout() {
    sessionStorage.clear();
    this.router.navigate(['login']);
  }
}
